'use es6';

import FilterOperatorErrorType from 'customer-data-filters/components/propTypes/FilterOperatorErrorType';
import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { syntheticEvent as SyntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIInputGroup from 'UIComponents/form/UIInputGroup';
import UISelect from 'UIComponents/input/UISelect';
import UITextInput from 'UIComponents/input/UITextInput';
import memoizeLast from 'transmute/memoizeLast';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getProtocol = str => {
  if (/^((http):\/\/)/i.test(str)) {
    return 'http://';
  } else if (/^((https):\/\/)/i.test(str)) {
    return 'https://';
  }
  return undefined;
};
const getDisplayValue = memoizeLast((str = '') => str.replace(/^((http|https):\/\/)*/i, ''));
const defaultProtocolValue = 'https://';
class FilterOperatorUrlInput extends Component {
  constructor(props) {
    super(props);
    this.getNextValue = (str, prevProtocol) => {
      const nextProtocol = getProtocol(str) || prevProtocol || defaultProtocolValue;
      const nextDisplayValue = getDisplayValue(str);
      this.setState({
        protocol: nextProtocol
      });
      return nextDisplayValue ? `${nextProtocol}${nextDisplayValue}` : undefined;
    };
    this.updateValue = currentValue => {
      const {
        onChange,
        value
      } = this.props;
      const {
        protocol
      } = this.state;
      const nextValue = this.getNextValue(currentValue, protocol);
      return onChange(SyntheticEvent(value.set('value', nextValue)));
    };
    this.handleProtocolChange = evt => {
      const {
        onChange,
        value
      } = this.props;
      const url = `${evt.target.value}${getDisplayValue(value.get('value'))}`;
      onChange(SyntheticEvent(value.set('value', url)));
      this.setState({
        protocol: evt.target.value
      });
    };
    this.handleDomainChange = evt => {
      const {
        target: {
          value
        }
      } = evt;
      return this.updateValue(value);
    };
    const initialValue = props.value.get('value');
    this.state = {
      protocol: initialValue ? getProtocol(initialValue) || defaultProtocolValue : defaultProtocolValue
    };
  }
  componentDidMount() {
    const initialValue = this.props.value.get('value');
    if (getDisplayValue(initialValue)) {
      this.updateValue(initialValue);
    }
  }
  render() {
    const {
      className,
      error,
      value,
      onBlur
    } = this.props;
    const {
      protocol
    } = this.state;
    const isError = error.get('error');
    const errorMessage = error.get('message');
    return /*#__PURE__*/_jsxs(UIInputGroup, {
      className: className,
      required: true,
      use: "itemLeft",
      children: [/*#__PURE__*/_jsx(UIFormControl, {
        "aria-label": I18n.text('customerDataFilters.FilterOperatorInput.ariaLabel'),
        children: /*#__PURE__*/_jsx(UISelect, {
          defaultValue: defaultProtocolValue,
          onChange: this.handleProtocolChange,
          options: [{
            text: 'https://',
            value: 'https://'
          }, {
            text: 'http://',
            value: 'http://'
          }],
          placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.FilterOperatorUrlInput.protocol.placeholder"
          }),
          value: protocol
        })
      }), /*#__PURE__*/_jsx(UIFormControl, {
        "aria-label": I18n.text('customerDataFilters.FilterOperatorInput.ariaLabel'),
        error: isError,
        validationMessage: isError ? errorMessage : null,
        children: /*#__PURE__*/_jsx(UITextInput, {
          onBlur: onBlur,
          onChange: this.handleDomainChange,
          value: getDisplayValue(value.get('value'))
        })
      })]
    });
  }
}
FilterOperatorUrlInput.propTypes = {
  className: PropTypes.string,
  error: FilterOperatorErrorType.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: FilterOperatorType.isRequired
};
export default FilterOperatorUrlInput;